import { useMemo } from 'react'
import EditableCell from './EditTableCell'
import EditableRow from './EditableRow'
import TableHasPagenation from './TableHasPagenation'
const components = {
    body: {
        row: EditableRow,
        cell: EditableCell
    }
}

export default function ProductListTable({
                                             otherColumns = [],
                                             pageData = {},
                                             loading = false,
                                             rowKey = 'skuId',
                                             editList = [],
                                             getList = () => {},
                                             handleSave = () => {}
                                         }) {
    const basicColoums = [
        {
            title: '商品信息',
            dataIndex: 'productName',
            width: '200px',
            render: (text, record) => {
                return (
                    <div style={{ fontSize: 12 }}>
                        <div style={{ color: '#1890ff' }}>{record.productName}</div>
                        <div>商品编码：{record.productCode}</div>
                        <div>商品条码：{record.barcode}</div>
                    </div>
                )
            }
        },
        {
            title: '规格',
            dataIndex: 'specification',
            width: '80px'
        },
        {
            title: '当前售价',
            width: '100px',
            dataIndex: 'salePrice'
        }
    ]
    const finalCol = useMemo(
        () =>
            [
                ...basicColoums,
                ...otherColumns
            ].map(item => {
                return editList.indexOf(item.dataIndex) > -1
                    ? {
                        ...item,
                        onCell: record => {
                            return {
                                record,
                                editable: true,
                                dataIndex: item.dataIndex,
                                title: item.title,
                                handleSave: handleSave,
                                inputFormatter: item.formatter,
                                isRs: item.isRs
                            }
                        }
                    }
                    : item
            }),
        [editList, otherColumns]
    )
    return (
        <TableHasPagenation
            pageData={pageData}
            components={components}
            scroll={{ x: 1300 }}
            rowKey={rowKey}
            loading={loading}
            onPageSizeChange={getList}
            columns={finalCol}
        />
    )
}
